/** Alíquotas do bloco de totais do evento. */
export const PERCENT_IMPOSTOS = 0.1425;
export const PERCENT_HONORARIOS = 0.08;
export const PERCENT_TAXA_ADMINISTRACAO = 0.06;

/**
 * Honorário da planilha como fração (0.08), a partir do cliente dela.
 *
 * A API manda `percentHonorarios` em pontos percentuais (8 = 8%), que é como
 * o usuário cadastra no cliente. A conversão mora só aqui: os cálculos e os
 * rótulos daqui para frente trabalham com fração, e ler o 8 cru em qualquer
 * um deles exibiria "800%". Sem o campo vale o padrão, o fixo de antes.
 */
export const taxaDeHonorarios = (
  planilha?: { percentHonorarios?: number | null } | null,
): number =>
  planilha?.percentHonorarios != null
    ? planilha.percentHonorarios / 100
    : PERCENT_HONORARIOS;

/**
 * Imposto "por dentro" sobre o total de serviços complementares.
 *
 * A alíquota incide sobre o valor JÁ com imposto, não sobre o custo. Então não
 * é `custo × 14,25%` — é quanto precisa ser somado ao custo para que os 14,25%
 * do valor final saiam do imposto e o custo continue inteiro:
 *
 *   base / (1 - 0,1425) - base   →   base / 0,8575 - base
 *
 * Na prática são ~16,62% da base, e não 14,25%. Cobrar por fora deixava a
 * Monumenta pagando a diferença: em R$ 100.000 de custo, R$ 2.368 a menos do
 * que o imposto efetivamente devido sobre o valor da AS.
 *
 * A alíquota vem daqui, e não escrita à mão, para que rótulo e valor não
 * possam divergir — quem lê "14,25%" na tela tem que estar vendo este cálculo.
 */
export const calcularImpostoPorDentro = (
  base: number,
  taxa: number = PERCENT_IMPOSTOS,
): number => base / (1 - taxa) - base;

/** Formata alíquota para rótulo: 0.1425 → "14,25%". */
export const formatarPercentual = (taxa: number): string =>
  `${(taxa * 100).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}%`;
